import { render, staticRenderFns } from "./DataIterator.vue?vue&type=template&id=60a79ace&scoped=true"
import script from "./DataIterator.vue?vue&type=script&lang=js"
export * from "./DataIterator.vue?vue&type=script&lang=js"
import style0 from "./DataIterator.vue?vue&type=style&index=0&id=60a79ace&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60a79ace",
  null
  
)

export default component.exports